export default __webpack_public_path__ + "static/banner_1400-b5cc135c282a3ea3787cf592ed13b64f.jpg";